export default {
  title: 'Virksomhedsoplysninger',
  form: {},
  buttons: {
    save: 'Gem',
  },
  toasts: {
    success: 'Dine oplysninger er gemt.',
  },
};
